import * as React from "react"
import { cn } from "../../lib/utils"

const Tabs = ({ defaultValue, children, className }: { defaultValue: string; children: React.ReactNode; className?: string }) => {
  const [activeTab, setActiveTab] = React.useState(defaultValue)
  return (
    <div className={className} data-active={activeTab}>
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement<any>, { activeTab, setActiveTab })
        }
        return child
      })}
    </div>
  )
}

const TabsList = ({ children, activeTab, setActiveTab, className }: any) => (
  <div className={cn("flex space-x-1 rounded-lg bg-muted p-1", className)}>
    {React.Children.map(children, child => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child as React.ReactElement<any>, { activeTab, setActiveTab })
      }
      return child
    })}
  </div>
)

const TabsTrigger = ({ value, children, activeTab, setActiveTab }: any) => (
  <button
    className={cn(
      "px-3 py-1.5 text-sm font-medium rounded-md transition-all",
      activeTab === value
        ? "bg-background text-foreground shadow"
        : "text-muted-foreground hover:text-foreground"
    )}
    onClick={() => setActiveTab(value)}
  >
    {children}
  </button>
)

const TabsContent = ({ value, children, activeTab }: any) => {
  if (activeTab !== value) return null
  return <div>{children}</div>
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
